import { RandomGradProgramsBlockData } from 'api/cms';
import { BlockMapping } from 'cms/blocks/BlockMapping';

import { AmpRandomGradProgramsBlock } from './AmpRandomGradProgramsBlock';
import { RandomGradProgramsBlock } from './RandomGradProgramsBlock';

export const RandomGradProgramsBlockMapping: BlockMapping<RandomGradProgramsBlockData> =
  {
    invariant: [],
    width: 'GRID',
    Component: RandomGradProgramsBlock,

    AmpComponent: AmpRandomGradProgramsBlock,
  };
